import {
	Container,
	ContainerPadding,
	TokenTextAppearance,
	TextAlignment,
	Image,
	Text,
	CTA,
	Breakpoints,
	Layout,
} from '@volkswagen-onehub/components-core';
import React from 'react';
import { ServiceLayer } from './services-layer-types';
import { PortalContext } from '../../../context/portal-context';
import { Environment } from '../../../enviroment';
import { Vehicle, GetPersonUser } from '@esportal/portal-service';
import { CitaPosventaLoader } from '../../guantera/components/cita-posventa-loader';
import { actionRedirect } from '../../../helpers/common-helpers';

export const LayerComponent = ({
	servicesLayerData,
	vehicle,
	userData,
}: {
	servicesLayerData: { isVisible: boolean; data: ServiceLayer };
	vehicle: Vehicle;
	userData: GetPersonUser;
}): React.ReactElement => {
	const { navigationService, userInteractionService } = React.useContext(PortalContext);

	const [renderFormCitaPosventa, setRenderFormCitaPosventa] = React.useState<{
		visibleForm: boolean;
		motivo?: string;
	}>({ visibleForm: false, motivo: undefined });

	const volkswagenRegex = /^https:\/\/www\.volkswagen\.es/;
	const generalUrlRegex = /^https:\/\/[^\s]+$/;

	const environmentPaths: { [key: string]: string } = {
		longdrive: Environment.getInstance().longdrive,
	};

	const handleClickCTAmyServices = async (link: string) => {
		const environmentPath = environmentPaths[link];
		const target = navigationService.navigateTo(environmentPath, {}, '#suscripciones');
		const kvpsCode = userData.portalUser.data.dealers?.pv.kvpsCode;

		//Action
		if (link.startsWith('action:')) {
			if (link === 'action:es-cca-loader--open_layer') {
				const finalLink = kvpsCode
					? `action:es-cca-loader--open_layer?dealer=${kvpsCode}`
					: 'action:es-cca-loader--open_layer';

				actionRedirect(userInteractionService, finalLink);
				return;
			}

			actionRedirect(userInteractionService, link);
			return;
		}

		// Calcular cuota
		if (link === 'https://www.volkswagen.es/es/clientes/longdrive.html#suscripciones') {
			window.open(link, '_blank', 'noopener,noreferrer');
			return;
		}

		if (link == 'es-oneform-cita-posventa-embedded') {
			setRenderFormCitaPosventa({ visibleForm: true, motivo: undefined });
		} else if (link == 'es-oneform-cita-posventa-embedded-pre-itv') {
			setRenderFormCitaPosventa({ visibleForm: true, motivo: 'PREITV' });
		} else if (volkswagenRegex.test(link)) {
			window.location.href = link;
		} else if (generalUrlRegex.test(link)) {
			window.open(link, '_blank');
		} else if (target) {
			target.push();
		}
	};

	return (
		<>
			{renderFormCitaPosventa.visibleForm && vehicle && (
				<CitaPosventaLoader
					vehicle={vehicle}
					motivo={renderFormCitaPosventa.motivo}
					onClose={() => setRenderFormCitaPosventa({ visibleForm: false, motivo: undefined })}
				/>
			)}
			<Container
				wrap={'always'}
				stretchContent
				padding={{
					left: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b960]: ContainerPadding.grid004,
					},
					right: {
						[Breakpoints.default]: ContainerPadding.grid001,
						[Breakpoints.b960]: ContainerPadding.grid004,
					},
				}}
			>
				<Container wrap="always" stretchContent>
					<Text appearance={TokenTextAppearance.headline500} textAlign={TextAlignment.left}>
						{servicesLayerData.data.title}
					</Text>
				</Container>
				<Container wrap="always" stretchContent padding={{ top: ContainerPadding.dynamic0130 }}>
					<Text appearance={TokenTextAppearance.copy200}>{servicesLayerData.data.subtitle}</Text>
				</Container>

				<Layout
					data-testid="services-layout"
					appearance={{
						[Breakpoints.default]: [
							{ name: 'a', columns: 24 },
							{ name: 'b', columns: 24 },
						],
						[Breakpoints.b960]: servicesLayerData.data.imageContent
							? [
									{ name: 'a', columns: 11 },
									{ name: '.', columns: 2 },
									{ name: 'b', columns: 11 },
								]
							: [{ name: 'a', columns: 24 }],
					}}
					allowOverflowingContent
				>
					{servicesLayerData.data.imageContent && (
						<Container wrap="always" stretchContent padding={{ top: ContainerPadding.dynamic0130 }}>
							<Image src={servicesLayerData.data.imageContent} alt="image content" />
						</Container>
					)}
					<Container wrap="always">
						{servicesLayerData.data.description && (
							<Container wrap="always" stretchContent padding={{ top: ContainerPadding.dynamic0130 }}>
								{servicesLayerData.data.description}
							</Container>
						)}
						{servicesLayerData.data.ctaText && servicesLayerData.data.link && (
							<Container wrap="always" stretchContent padding={{ top: ContainerPadding.dynamic0100 }}>
								<Text appearance={TokenTextAppearance.copy200}>
									<CTA
										tag="a"
										emphasis="primary"
										onClick={() => handleClickCTAmyServices(servicesLayerData.data.link!)}
									>
										{servicesLayerData.data.ctaText}
									</CTA>
								</Text>
							</Container>
						)}
					</Container>
				</Layout>

				{servicesLayerData.data.descriptionFooter && (
					<Container wrap="always" stretchContent padding={{ top: ContainerPadding.dynamic0130 }}>
						{servicesLayerData.data.descriptionFooter}
					</Container>
				)}
				{servicesLayerData.data.imageFooter && (
					<Container wrap="always" stretchContent padding={{ top: ContainerPadding.dynamic0130 }}>
						<Image src={servicesLayerData.data.imageFooter} alt="image footer" />
					</Container>
				)}
			</Container>
		</>
	);
};
